import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SupplierPluginsNames } from '../models/supplier-outlet.model';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class DynamicFunctionalityGuard  {
  private readonly modulesAccess = {
    debt: SupplierPluginsNames.IsDebit,
    'catalog/tare': SupplierPluginsNames.IsPackingReturn,
  };

  constructor(private router: Router, private storageService: StorageService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const config = this.modulesAccess[next.routeConfig.path];
    if (!config) {
      this.router.navigate(['/suppliers']);
      return of(false);
    }
    const raw = this.storageService.getFromLocalStorage('selectedUserSupplierPlugins');
    let supplierPlugins: any = null;
    if (raw) {
      try {
        supplierPlugins = JSON.parse(raw);
      } catch {
        supplierPlugins = null;
      }
    }
    if (!Array.isArray(supplierPlugins) || supplierPlugins.length === 0) {
      this.router.navigate(['/suppliers']);
      return of(false);
    }
    if (
      !supplierPlugins.find((s) => s.pluginName === config && s.pluginValue)
    ) {
      this.router.navigate(['/suppliers']);
      return of(false);
    }
    return of(true);
  }
}
